import Alpine from 'alpinejs';
document.addEventListener('alpine:init', function () {
  Alpine.data('helpCenter', function () {
    return {
      haveResults: false,
      fetchingResults: false,
      resultsInfo: '',
      resultsContent: '',
      // On load, check if URL includes help search query and grab initial results
      init: function init() {
        var _this = this;
        this.setQueryAndInitSearch();
        // Add event listener for history pop (back/forward button) to trigger search input/results updates
        // if back button goes to seperate page, event does not fire
        window.addEventListener('popstate', function (event) {
          _this.setQueryAndInitSearch();
        });
        // check if there's a question parameter and open question accordion if exists
        var urlParams = new URLSearchParams(window.location.search);
        var initialQuestionParam = urlParams.get('question');
        if (initialQuestionParam) {
          var questionSummary = document.querySelector("#accordion-header-".concat(initialQuestionParam));
          if (questionSummary) {
            // Need to check ready state, since if page isn't ready then running click function on
            // summary will not trigger the event
            if (document.readyState !== 'complete') {
              document.addEventListener('DOMContentLoaded', function () {
                questionSummary.click();
              });
            } else {
              questionSummary.click();
            }
          }
        }
      },
      setQueryAndInitSearch: function setQueryAndInitSearch() {
        var urlParams = new URLSearchParams(window.location.search);
        var initialQueryParam = urlParams.get('query');
        if (initialQueryParam) {
          // Need to deal with search form input displaying encoded text as in url
          // (i.e. displaying spaces as +), instead of decoding first
          if (this.$refs.helpSearchQuery) {
            this.$refs.helpSearchQuery.value = initialQueryParam;
            this.fetchResults(initialQueryParam);
          }
        } else {
          this.clearSearchResults();
        }
      },
      // On search clear remove any search query from the URL as well
      clearSearchResults: function clearSearchResults() {
        if (!Shopify.designMode) {
          var url = new URL(window.location);
          url.searchParams["delete"]('query');
          history.pushState(null, '', url);
        }
        this.haveResults = false;
        if (this.$refs.helpSearchQuery) {
          this.$refs.helpSearchQuery.value = '';
        }
      },
      submitHelpSearchForm: function submitHelpSearchForm(event) {
        event.preventDefault();
        var query = event.target.querySelector('#help-center-query');
        this.fetchResults(query.value);
      },
      fetchResults: function fetchResults(query) {
        var _this2 = this;
        // update the page URL to include current query (without reloading page)
        if (!Shopify.designMode) {
          var url = new URL(window.location);
          url.searchParams.set('query', query);
          history.pushState(null, '', url);
        }
        // fetch the results for the new query
        this.haveResults = false;
        this.fetchingResults = true;
        fetch("".concat(routes.search_url, "?sections=template-search-help-center&q=").concat(query)).then(function (response) {
          if (response.ok && response.status < 400) {
            return response.json();
          } else {
            console.error('Could not fetch search results', response);
            _this2.fetchingResults = false;
            _this2.haveResults = false;
          }
        }).then(function (results) {
          var contentsString = results['template-search-help-center'];
          var contents = document.createElement('div');
          contents.innerHTML = contentsString;
          _this2.resultsInfo = contents.querySelector('#help-results-info').innerHTML;
          _this2.resultsContent = contents.querySelector('#help-results-content').innerHTML;
          _this2.fetchingResults = false;
          _this2.haveResults = true;
        });
      }
    };
  });
});